import { FC } from 'react'
import cn from 'classnames'
import ReactModal from 'react-modal'

import { useActionModalContext } from 'backoffice/components/DropRequests/Modals/ConfirmationModal/ActionModalContext'
import ActionForm from './ActionForm'

import styles from './ConfirmationModal.module.scss'

//Assets
import { ReactComponent as IconClose } from 'images/icons/close.svg'

const ConfirmationModal: FC = () => {
  const { actionModal, setActionModal } = useActionModalContext()

  if (!actionModal) {
    return null
  }

  const { action, petition } = actionModal

  const handleClose = () => setActionModal(null)

  return (
    <ReactModal
      isOpen={!!actionModal.petition}
      className={cn(styles.modal)}
      shouldFocusAfterRender={true}
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
      onRequestClose={handleClose}
    >
      <div className={styles.content}>
        <IconClose className={styles.iconClose} width="24" height="24" onClick={handleClose} />
        <div className={styles.sectionName}>{`${action} Drop`}</div>
        <div className={styles.title}>{petition.drop.name}</div>
        <ActionForm
          id={petition.id}
          action={action}
          requestedAmount={petition.amount_requested}
          handleClose={handleClose}
        />
      </div>
    </ReactModal>
  )
}

export default ConfirmationModal
